import { getRequestEvent, isServer } from 'solid-js/web';
import { renderContext } from '~/platform/renderContext';
import type { HostInfo } from '~/use-cases/types/HostInfo';
import { getEnvConfig } from './env';

export const getRequestURL = () => {
  if (isServer) {
    const event = getRequestEvent();
    if (event) {
      return new URL(event.request.url);
    }
    throw new Error('No request event found');
  }
};

export const getCurrentHostName = (): HostInfo => {
  if (import.meta.env.DEV) {
    const devCompanyHost = import.meta.env.VITE_DEV_COMPANY_HOST || 'hogwarts';
    const clientPortalUrl = getEnvConfig().getClientPortalUrl(devCompanyHost);
    return {
      hostname: new URL(clientPortalUrl).hostname,
    };
  }

  const requestURL = getRequestURL();
  if (requestURL) {
    return {
      hostname: requestURL.hostname,
      path: requestURL.pathname,
    };
  }

  const page = new URL(renderContext.pageUrl() ?? '');
  return {
    hostname: page.hostname,
    path: page.pathname,
  };
};
